/**
 * The line rows of an order modal. Call sites pass either .multi-order-table or
 * its tbody, and the thead <tr> must never be counted as a row.
 */
export function orderRowsIn($table) {
    var $bodyRows = $table.find('tbody tr');

    return ($bodyRows.length ? $bodyRows : $table.find('tr')).not(
        '.default-row'
    );
}

/**
 * A row with neither .valid nor .error was never looked up: no brand chosen yet,
 * or a lookup that a newer request took over. Order::compileItems() skips any line
 * with an empty AAIABrandCode or PartNumber, so submitting one silently drops it
 * while the response still reports a successful add.
 */
function hasUnverifiedRow($table) {
    return orderRowsIn($table).not('.valid').not('.error').length > 0;
}

export function validateOrderRows($table) {
    var $form = $table.closest('form');

    if (
        !$table.find('tr.error').length &&
        !hasUnverifiedRow($table) &&
        $table.find('.multi-order-brand').length > 1
    ) {
        $form.find('button[type="submit"]').prop('disabled', false);
        if (!$table.find('tr.no-inst').length) {
            $form.find('.instant-order').prop('disabled', false);
            $form.find('.instant-order').attr('title', '');
        } else {
            $form.find('.instant-order').prop('disabled', true);
            $form
                .find('.instant-order')
                .attr(
                    'title',
                    'Instant Ordering Unavailable: Your default warehouse has no inventory. Add to Order to select a location.'
                );
        }
    } else {
        $form.find('button[type="submit"]').prop('disabled', true);
        $form.find('.instant-order').prop('disabled', true);
        $form
            .find('.instant-order')
            .attr('title', 'Instant Ordering Unavailable.');
    }
}

export function renameOrderRows($table) {
    var idx = 0;
    // Body rows only — thead <tr> was consuming index 0, shifting items[n] and breaking POST shape.
    $table.find('tbody tr').each(function () {
        var $iteratedRow = $(this);

        if ($iteratedRow.hasClass('default-row')) {
            $iteratedRow
                .find('.multi-order-brand, .multi-order-part-number, .multi-order-quantity, .multi-order-gtin')
                .removeAttr('name');
            return;
        }

        $iteratedRow
            .find('.multi-order-brand')
            .attr('name', 'items[' + idx + '][AAIABrandCode]');
        $iteratedRow
            .find('.multi-order-part-number')
            .attr('name', 'items[' + idx + '][PartNumber]');
        $iteratedRow
            .find('.multi-order-quantity')
            .attr('name', 'items[' + idx + '][Quantity]');
        idx++;
    });
}
